export const selectActiveOperation = (state) => state.probing.activeOperation;
export const selectOperations = (state) => state.probing.program.cmds;
export const selectProgramArgs = (state) => state.probing.program.args;
